import { SearchStateFactory } from './SearchStateFactory';

const getMock: () => Partial<SearchStateFactory> = () => ({
    newSearchState: () =>
        ({
            pageState: {
                resultsPerPage: 10
            }
        }) as any
});

export const searchStateFactoryMock = {
    getMock,
    provider: (Service: typeof SearchStateFactory) => ({
        provide: Service,
        useValue: getMock()
    })
};
